import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../../pages/seo";
import { slugify } from "../../utils/slugify";

const LandingPageAccount = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  // Icon mapping function based on section title
  const getSectionIcon = (title) => {
    const iconMap = {
      "Manage Your Xpage Account": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.25 13.25V9.93746C13.25 6.62496 15.4583 4.41663 18.7708 4.41663H34.2291C37.5416 4.41663 39.75 6.62496 39.75 9.93746V13.25"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 35.3333C29.8135 35.3333 32.5 32.6468 32.5 29.3333C32.5 26.0198 29.8135 23.3333 26.5 23.3333C23.1865 23.3333 20.5 26.0198 20.5 29.3333C20.5 32.6468 23.1865 35.3333 26.5 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.3333 35.3333L33.125 33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "General Landing Page Settings": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.25 13.25V9.93746C13.25 6.62496 15.4583 4.41663 18.7708 4.41663H34.2291C37.5416 4.41663 39.75 6.62496 39.75 9.93746V13.25"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 35.3333C29.8135 35.3333 32.5 32.6468 32.5 29.3333C32.5 26.0198 29.8135 23.3333 26.5 23.3333C23.1865 23.3333 20.5 26.0198 20.5 29.3333C20.5 32.6468 23.1865 35.3333 26.5 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.3333 35.3333L33.125 33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Manage Landing Page Brand Assets": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.1666 21.1666L26.5 26.5L31.8333 21.1666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.1666 31.8333L26.5 26.5L31.8333 31.8333"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),

      "Online Store": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.1666 21.1666L26.5 26.5L31.8333 21.1666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.1666 31.8333L26.5 26.5L31.8333 31.8333"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Change your plan": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 17.6666V13.25M26.5 39.75V35.3333M35.3333 26.5H39.75M13.25 26.5H17.6666M31.8333 31.8333L35.3333 35.3333M21.1666 21.1666L17.6666 17.6666M31.8333 21.1666L35.3333 17.6666M21.1666 31.8333L17.6666 35.3333"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Deactivate your store": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.6666 17.6666L35.3333 35.3333M35.3333 17.6666L17.6666 35.3333M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Roles and permissions": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 17.6666H13.25C8.38163 17.6666 4.41663 21.6316 4.41663 26.5V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V26.5C48.5833 21.6316 44.6184 17.6666 39.75 17.6666Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 17.6666V13.25C17.6666 9.00996 21.0933 5.58329 25.3333 5.58329H27.6666C31.9066 5.58329 35.3333 9.00996 35.3333 13.25V17.6666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 35.3333C28.4762 35.3333 30.0833 33.7262 30.0833 31.75C30.0833 29.7738 28.4762 28.1666 26.5 28.1666C24.5238 28.1666 22.9166 29.7738 22.9166 31.75C22.9166 33.7262 24.5238 35.3333 26.5 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.3333 35.3333H39.75"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.3333 39.75H39.75"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    };

    return (
      iconMap[title] || (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 17.6666V26.5L31.9375 31.9375"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    );
  };

  const helpSections = [
    {
      title: "Landing Page & Account",
      description: "Manage your xPage account and landing page settings",
      items: [
        {
          id: "landing-page-account",
          title: "Landing Page & Account",
          description:
            "Your Xpage landing page is the digital face of your brand, showcasing products, services, and promotions in a fully customizable layout. From your xPage account, you control every aspect of this landing page — from adding brand assets like logos, colors, and social media links, to managing content, apps, and integrations. Your account serves as the central hub where you configure settings, track performance, handle customer interactions, and manage billing, staff, and security. With Xpage, everything you need to create, optimize, and operate a professional landing page is accessible in one intuitive platform.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.25 13.25V9.93746C13.25 6.62496 15.4583 4.41663 18.7708 4.41663H34.2291C37.5416 4.41663 39.75 6.62496 39.75 9.93746V13.25"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M26.5 35.3333C29.8135 35.3333 32.5 32.6468 32.5 29.3333C32.5 26.0198 29.8135 23.3333 26.5 23.3333C23.1865 23.3333 20.5 26.0198 20.5 29.3333C20.5 32.6468 23.1865 35.3333 26.5 35.3333Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M35.3333 35.3333L33.125 33.125"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          sections: [
            {
              id: "Manage Your Xpage Account",
              title: "Manage Your Xpage Account",
              description:
                "Configure account settings, security, and user preferences for your xPage account.",
            },
            {
              id: "General Landing Page Settings",
              title: "General Landing Page Settings",
              description:
                "Customize your landing page layout, navigation, and general appearance settings.",
            },
            {
              id: "Manage Landing Page Brand Assets",
              title: "Manage Landing Page Brand Assets",
              description:
                "Upload and manage logos, colors, fonts, and other brand elements for your landing page.",
            },
            {
              id: "Online Store",
              title: "Online Store",
              description:
                "Build, launch, and manage your complete online store directly inside xPage. ",
            },
            {
              id: "Change your plan",
              title: "Change your plan",
              description:
                "Upgrade, downgrade, or modify your xPage subscription plan to match your business needs.",
            },
            {
              id: "Deactivate your store",
              title: "Deactivate your store",
              description:
                "Temporarily deactivate or permanently close your xPage store and landing page.",
            },
            {
              id: "Roles and permissions",
              title: "Roles and permissions",
              description:
                "Manage team member access and permissions for your xPage account and landing page.",
            },
          ],
        },
      ],
    },
  ];

  // Handle card click - use the exact section names from sidebar
  // Handle card click - update URL with section like sidebar (no slugs)
const handleCardClick = (itemId, sectionId) => {
  navigate(`/help/${slugify(itemId)}/${slugify(sectionId)}`);
};
  // Filter items based on search query
  const filteredSections = helpSections
    .map((section) => ({
      ...section,
      items: section.items.filter(
        (item) =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          section.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.sections.some(
            (sectionItem) =>
              sectionItem.title
                .toLowerCase()
                .includes(searchQuery.toLowerCase()) ||
              sectionItem.description
                .toLowerCase()
                .includes(searchQuery.toLowerCase()),
          ),
      ),
    }))
    .filter((section) => section.items.length > 0);

  return (
    <div className="min-h-screen flex flex-col md:pt-10 pt-16">
      <SEO
        title="Landing Page & Account – xPage Help Center"
        description="Learn how to manage your Xpage account, landing page settings, brand assets, and more."
        keywords="xPage, landing page, account, help center, brand assets"
        canonical="https://help.xpage.ai/help/landing-page-account/landing-page-account"
        type="article"
      />

      <div className="flex-1 w-full py-6 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header with Description */}
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-systemTitle mb-3">
              Landing Page & Account
            </h1>

            {/* Added description text */}
            <div className="mb-6">
              <p className="text-sm text-systemSubTitle leading-relaxed">
                Your Xpage landing page is the digital face of your brand,
                showcasing products, services, and promotions in a fully
                customizable layout. From your xPage account, you control every
                aspect of this landing page — from adding brand assets like
                logos, colors, and social media links, to managing content,
                apps, and integrations. Your account serves as the central hub
                where you configure settings, track performance, handle customer
                interactions, and manage billing, staff, and security. With
                Xpage, everything you need to create, optimize, and operate a
                professional landing page is accessible in one intuitive
                platform.
              </p>
            </div>
          </div>

          {/* Spacing between description and cards */}
          <div className="mb-6"></div>

          {/* Help Sections */}
          <div className="space-y-6">
            {filteredSections.map((section, sectionIndex) => (
              <div key={sectionIndex} className="p-4">
                <h2 className="text-lg font-semibold text-systemTitle mb-4">
                  {section.title}
                </h2>
                <p className="text-sm text-systemLabel mb-6">
                  {section.description}
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {section.items.flatMap((item) =>
                    item.sections.map((sectionItem, sectionIndex) => (
                      <div
                        key={sectionIndex}
                        onClick={() => handleCardClick(item.id, sectionItem.id)}
                        className="group relative bg-white border border-gray-200 rounded-xl p-4 hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1 cursor-pointer hover:border-systemLabel"
                      >
                        {/* Hover effect background */}
                        <div className="absolute inset-0 bg-gradient-to-br from-deepPurple/5 to-transparent opacity-0 group-hover:opacity-100 rounded-xl transition-opacity duration-300"></div>

                        <div className="relative z-10">
                          {/* Icon and Title */}
                          <div className="flex items-center space-x-3 mb-3">
                            <div className="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center transition-colors duration-300 group-hover:bg-deepPurple/5">
                              {getSectionIcon(sectionItem.title)}
                            </div>
                            <h3 className="text-lg font-semibold text-systemTitle transition duration-300">
                              {sectionItem.title}
                            </h3>
                          </div>

                          {/* Section-specific description */}
                          <p className="text-sm text-systemLabel leading-relaxed transition-colors duration-300">
                            {sectionItem.description}
                          </p>

                          {/* Hover arrow indicator */}
                          <div className="absolute right-4 top-4 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
                            <svg
                              className="w-7 h-7 text-base"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    )),
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPageAccount;
